"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _Preloader = _interopRequireDefault(require("./Preloader.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UiPreloader = (0, _component.default)(() => import("@micado-digital/react-ui/components/UiPreloader"));
const Preloader = () => {
  const css = (0, _Preloader.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.preloader, "mco-shop-preloader")
  }, /*#__PURE__*/_react.default.createElement(UiPreloader, null));
};
var _default = exports.default = Preloader;